export default __webpack_public_path__ + "static/media/mfp03.4793d536.jpg";